<template>
  <div class="quotationFreight">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <div class="title" v-if="isView">{{ $t.onlineOrder.viewTitle1 }}</div>
      <div v-else>
        <div class="title" v-if="FPId">{{ $t.onlineOrder.editTitle1 }}</div>
        <div class="title" v-else>{{ $t.onlineOrder.addTitle1 }}</div>
      </div>

      <van-field
        v-model="form.CountryName"
        :label="$t.onlineOrder.countryName"
        @click="onShowEmit('showQuotationFreightCountry')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        :required="!isView ? true : false"
        :rules="formRule"
        type="textarea"
      />

      <van-field
        :label="$t.onlineOrder.countryFlag"
        :required="!isView ? true : false"
        :rules="formRule"
      >
        <template #input>
          <van-uploader
            v-model="nationalFlagPicture"
            :max-count="1"
            :after-read="afterRead1"
            :deletable="!isView ? true : false"
          />
        </template>
      </van-field>

      <div class="multi-table" v-if="form.DetailList">
        <van-field name="stepper" :label="$t.onlineOrder.stepper2">
          <template #input>
            <van-stepper
              :min="1"
              :value="form.DetailList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
              :disabled="isView ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.DetailList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)" v-if="!isView">
              <van-icon name="close" />
            </div>
          </div>

          <van-field
            v-model="item.CargoCategory"
            :label="$t.onlineOrder.cargoCategory"
            :placeholder="$t.meta.input"
            :disabled="isView ? true : false"
            :required="!isView ? true : false"
            :rules="formRule"
          />

          <van-field
            v-model="item.CargoCategoryEn"
            :label="$t.onlineOrder.cargoCategoryEn"
            :placeholder="$t.meta.input"
            :disabled="isView ? true : false"
            :required="!isView ? true : false"
            :rules="formRule"
          />

          <van-field
            v-model="item.FirstWeight"
            :label="$t.onlineOrder.firstWeight"
            :placeholder="$t.meta.input"
            :disabled="isView ? true : false"
            :required="!isView ? true : false"
            :rules="formRule"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />

          <van-field
            v-model="item.FirstWeightPrice"
            :label="$t.onlineOrder.firstWeightPrice"
            :placeholder="$t.meta.input"
            :disabled="isView ? true : false"
            :required="!isView ? true : false"
            :rules="formRule"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />

          <van-field
            v-model="item.ContinuousWeight"
            :label="$t.onlineOrder.continueWeight"
            :placeholder="$t.meta.input"
            :disabled="isView ? true : false"
            :required="!isView ? true : false"
            :rules="formRule"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />

          <van-field
            v-model="item.ContinuousWeightPrice"
            :label="$t.onlineOrder.continuePrice"
            :placeholder="$t.meta.input"
            :disabled="isView ? true : false"
            :required="!isView ? true : false"
            :rules="formRule"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />

          <van-field
            v-model="item.SCIdStr"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showQuotationFreightCurrency')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            :required="!isView ? true : false"
            :rules="formRule"
          />

          <van-field
            v-model="item.WeightUnitStr"
            :label="$t.onlineOrder.weightUnit"
            @click="pickerShow(index, 'showQuotationFreightUnit')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            :required="!isView ? true : false"
            :rules="formRule"
          />

          <van-field
            v-model="item.TransportationDuration"
            :label="$t.onlineOrder.transportTime"
            :placeholder="$t.meta.input"
            :required="!isView ? true : false"
            :rules="formRule"
          />

          <van-field
            v-model="item.WMIdStr"
            :label="$t.onlineOrder.warehouseGoods"
            @click="pickerShow(index, 'showQuotationFreightWarehouse')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            :required="!isView ? true : false"
            :rules="formRule"
          />

          <van-field
            v-model="item.ConversionFactor"
            :label="$t.onlineOrder.conversionFactor"
            :placeholder="$t.meta.input"
            :disabled="isView ? true : false"
            :required="!isView ? true : false"
            :rules="formRule"
          />

          <van-field
            v-model="item.LogisticsChannelStr"
            :label="$t.onlineOrder.serviceProvider"
            @click="pickerShow(index, 'showQuotationFreightChannel')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />

          <van-field
            v-model="item.LogisticsProductCodeStr"
            :label="$t.onlineOrder.productCode"
            @click="pickerShow(index, 'showQuotationFreightProductCode')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            v-if="item.LogisticsChannel == 2"
            :required="!isView ? true : false"
            :rules="formRule"
          />

          <van-field
            v-model="item.Remark"
            :label="$t.onlineOrder.remark"
            :placeholder="!isView ? $t.meta.input : ''"
            :disabled="isView ? true : false"
            type="textarea"
            rows="3"
          />

          <van-field
            v-model="item.RemarkEn"
            :label="$t.onlineOrder.remarkEn"
            :placeholder="!isView ? $t.meta.input : ''"
            :disabled="isView ? true : false"
            type="textarea"
            rows="3"
          />

          <van-field :label="$t.onlineOrder.logoImg">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.LogoIcon))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.LogoIcon"
                native-type="button"
                >{{ $t.meta.view }}</van-button
              >
              <span v-if="isView">
                <div v-if="!item.LogoIcon">{{ $t.onlineOrder.noImage }}</div>
              </span>
              <van-uploader
                :after-read="afterRead2"
                @click-upload="uploaderClick(index)"
                v-if="!isView"
              >
                <van-image
                  :src="item.LogoIcon && imgUrlFilter(item.LogoIcon)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.LogoIcon"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  native-type="button"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>

          <span v-if="!isView">
            <van-field
              v-model="item.DeclaredValueThreshold"
              :label="$t.onlineOrder.declareValue"
              :placeholder="$t.meta.input"
              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
            />

            <van-field
              v-model="item.DeclaredValueCurrencyIdStr"
              :label="$t.onlineOrder.declareValueCurrency"
              @click="pickerShow(index, 'showQuotationDeclaredValueCurrency')"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field
              v-model="item.VatRate"
              :label="$t.onlineOrder.vatRate + '(%)'"
              :placeholder="$t.meta.input"
              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
            />

            <van-field
              v-model="item.MinVatAmount"
              :label="$t.onlineOrder.minVatAmount"
              :placeholder="$t.meta.input"
              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
            />

            <van-field
              v-model="item.MinVatCurrencyIdStr"
              :label="$t.onlineOrder.minVatCurrency"
              @click="pickerShow(index, 'showQuotationMinVatCurrency')"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field
              v-model="item.CustomsDutyRate"
              :label="$t.onlineOrder.customsDutyRate + '(%)'"
              :placeholder="$t.meta.input"
              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
            />

            <van-field
              v-model="item.MinCustomsDutyAmount"
              :label="$t.onlineOrder.minCustomsDutyAmount"
              :placeholder="$t.meta.input"
              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
            />

            <van-field
              v-model="item.MinCustomsDutyCurrencyIdStr"
              :label="$t.onlineOrder.minCustomsDutyCurrency"
              @click="pickerShow(index, 'showQuotationMinCustomsDutyCurrency')"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field
              v-model="item.HighValueFee"
              :label="$t.onlineOrder.highValueFee"
              :placeholder="$t.meta.input"
              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
            />

            <van-field
              v-model="item.HighValueFeeCurrencyIdStr"
              :label="$t.onlineOrder.highValueFeeCurrency"
              @click="pickerShow(index, 'showQuotationHighValueFeeCurrency')"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field :label="$t.onlineOrder.productTaxRateList">
              <template #input>
                <van-badge :content="form.DetailList[index].ProductTaxList.length">
                  <van-button
                    @click="dialogProductTaxShow(index)"
                    type="info"
                    size="small"
                    native-type="button"
                    >{{ $t.meta.editButton }}</van-button
                  >
                </van-badge>
              </template>
            </van-field>
          </span>
        </div>
      </div>

      <div style="margin: 16px" v-if="!isView">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showQuotationFreightCurrency" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="currencyConfirm($event)"
        @cancel="showQuotationFreightCurrency = false"
      />
    </van-popup>

    <van-popup v-model="showQuotationFreightWarehouse" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.warehouseGoods"
        show-toolbar
        :columns="warehouseList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="warehouseConfirm($event)"
        @cancel="showQuotationFreightWarehouse = false"
      />
    </van-popup>

    <van-popup v-model="showQuotationFreightUnit" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.weightUnit"
        show-toolbar
        :columns="unitList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="unitConfirm($event)"
        @cancel="showQuotationFreightUnit = false"
      />
    </van-popup>

    <van-popup v-model="showQuotationFreightChannel" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.serviceProvider"
        show-toolbar
        :columns="channelList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="channelConfirm($event)"
        @cancel="showQuotationFreightChannel = false"
      />
    </van-popup>

    <van-popup v-model="showQuotationFreightProductCode" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.productCode"
        show-toolbar
        :columns="productCodeList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="productCodeConfirm($event)"
        @cancel="showQuotationFreightProductCode = false"
      />
    </van-popup>

    <option-list
      event="showQuotationFreightCountry"
      :options="countryList"
      @onSelect="countryConfirm"
    ></option-list>

    <!-- tax -->
    <van-popup v-model="showQuotationDeclaredValueCurrency" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.declareValueCurrency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="declaredValueCurrencyConfirm($event)"
        @cancel="showQuotationDeclaredValueCurrency = false"
      />
    </van-popup>

    <van-popup v-model="showQuotationMinVatCurrency" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.minVatCurrency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="minVatCurrencyConfirm($event)"
        @cancel="showQuotationMinVatCurrency = false"
      />
    </van-popup>

    <van-popup v-model="showQuotationMinCustomsDutyCurrency" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.minCustomsDutyCurrency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="minCustomsDutyCurrencyConfirm($event)"
        @cancel="showQuotationMinCustomsDutyCurrency = false"
      />
    </van-popup>

    <van-popup v-model="showQuotationHighValueFeeCurrency" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.highValueFeeCurrency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="highValueFeeCurrencyConfirm($event)"
        @cancel="showQuotationHighValueFeeCurrency = false"
      />
    </van-popup>

    <van-dialog
      :title="$t.onlineOrder.productTaxRateList"
      width="90%"
      v-model="dialogProductTaxVisible"
      @cancel="dialogProductTaxVisible = false"
      :cancel-button-text="$t.meta.close"
      :show-cancel-button="true"
      :show-confirm-button="false"
      className="quotationFreight-dialog"
    >
      <slot name="default">
        <div class="quotationFreight-alert">
          <div
            class="multi-table"
            v-if="form.DetailList[formIndex] && form.DetailList[formIndex].ProductTaxList"
          >
            <van-field name="stepper" :label="$t.onlineOrder.productTaxRateList">
              <template #input>
                <van-stepper
                  :min="1"
                  :value="form.DetailList[formIndex].ProductTaxList.length"
                  @minus="handleDelProductTax"
                  @plus="handleAddProductTax"
                  :disable-input="true"
                />
              </template>
            </van-field>
            <div
              v-for="(item, index) in form.DetailList[formIndex].ProductTaxList"
              :key="index"
            >
              <div class="multi-table-header">
                <div class="multi-table-title">No.{{ index + 1 }}</div>
              </div>

              <van-field
                v-model="item.ProductCategory"
                :label="$t.onlineOrder.productCategory"
                :placeholder="$t.meta.input"
                required
              />

              <van-field
                v-model="item.VatRate"
                :label="$t.onlineOrder.vatRate + '(%)'"
                :placeholder="$t.meta.input"
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
              />

              <van-field
                v-model="item.MinVatAmount"
                :label="$t.onlineOrder.minVatAmount"
                :placeholder="$t.meta.input"
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
              />

              <van-field
                v-model="item.MinVatCurrencyIdStr"
                :label="$t.onlineOrder.minVatCurrency"
                @click="productTaxPickerShow(index, 'showProductTaxMinVatCurrency')"
                :placeholder="$t.meta.select"
                clickable
                readonly
              />

              <van-field
                v-model="item.CustomsDutyRate"
                :label="$t.onlineOrder.customsDutyRate + '(%)'"
                :placeholder="$t.meta.input"
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
              />

              <van-field
                v-model="item.MinCustomsDutyAmount"
                :label="$t.onlineOrder.minCustomsDutyAmount"
                :placeholder="$t.meta.input"
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
              />

              <van-field
                v-model="item.MinCustomsDutyCurrencyIdStr"
                :label="$t.onlineOrder.minCustomsDutyCurrency"
                @click="
                  productTaxPickerShow(index, 'showProductTaxMinCustomsDutyCurrency')
                "
                :placeholder="$t.meta.select"
                clickable
                readonly
              />
            </div>
          </div>
        </div>
      </slot>
    </van-dialog>

    <van-popup v-model="showProductTaxMinVatCurrency" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.minVatCurrency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="productTaxMinVatCurrencyConfirm($event)"
        @cancel="showProductTaxMinVatCurrency = false"
      />
    </van-popup>

    <van-popup v-model="showProductTaxMinCustomsDutyCurrency" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.minCustomsDutyCurrency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="productTaxHighValueFeeCurrencyConfirm($event)"
        @cancel="showProductTaxMinCustomsDutyCurrency = false"
      />
    </van-popup>
  </div>
</template>
<script>
import OptionList from "@components/optionList/OptionList.vue";
import Vue from "vue";
import {
  Form,
  Field,
  Checkbox,
  Button,
  Icon,
  Image,
  Uploader,
  Picker,
  Popup,
  Stepper,
  Badge,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Checkbox)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Stepper)
  .use(Badge);

export default {
  name: "quotationFreight",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      FPId: "",
      isView: false,
      CustomerId: null,
      form: {
        FPId: "",
        CountryName: "",
        CountryId: null,
        NationalFlagPicture: "",
        DetailList: [
          {
            CargoCategory: "",
            CargoCategoryEn: "",
            FirstWeight: "",
            FirstWeightPrice: "",
            ContinuousWeight: "",
            ContinuousWeightPrice: "",
            SCId: null,
            SCIdStr: "",
            TransportationDuration: "",
            WMId: null,
            WMIdStr: "",
            WeightUnit: null,
            WeightUnitStr: "",
            Remark: "",
            RemarkEn: "",
            LogoIcon: "",
            ConversionFactor: null,
            LogisticsChannel: null,
            LogisticsChannelStr: null,
            LogisticsProductCode: "",
            LogisticsProductCodeStr: "",
            //tax
            DeclaredValueThreshold: null,
            DeclaredValueCurrencyId: null,
            DeclaredValueCurrencyIdStr: "",
            VatRate: null,
            MinVatAmount: null,
            MinVatCurrencyId: null,
            MinVatCurrencyIdStr: "",
            CustomsDutyRate: null,
            MinCustomsDutyAmount: null,
            MinCustomsDutyCurrencyId: null,
            MinCustomsDutyCurrencyIdStr: "",
            HighValueFee: null,
            HighValueFeeCurrencyId: null,
            HighValueFeeCurrencyIdStr: "",
            ProductTaxList: [
              {
                ProductCategory: "",
                VatRate: null,
                MinVatAmount: null,
                MinVatCurrencyId: null,
                MinVatCurrencyIdStr: "",
                CustomsDutyRate: null,
                MinCustomsDutyAmount: null,
                MinCustomsDutyCurrencyId: null,
                MinCustomsDutyCurrencyIdStr: "",
              },
            ],
          },
        ],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      nationalFlagPicture: [],
      //picker
      warehouseList: [],
      showQuotationFreightWarehouse: false,
      countryList: [],
      showQuotationFreightCountry: false,
      currencyList: [],
      showQuotationFreightCurrency: false,
      unitList: [
        {
          text: "kg",
          value: 1,
        },
        {
          text: "cbm",
          value: 2,
        },
      ],
      showQuotationFreightUnit: false,
      itemIndex: 0,
      //服务商
      channelList: [],
      showQuotationFreightChannel: false,
      productCodeList: [],
      showQuotationFreightProductCode: false,
      //图标
      filesIndex: 0,
      //tax
      showQuotationDeclaredValueCurrency: false,
      showQuotationMinVatCurrency: false,
      showQuotationMinCustomsDutyCurrency: false,
      showQuotationHighValueFeeCurrency: false,
      formIndex: 0,
      formItemIndex: 0,
      dialogProductTaxVisible: false,
      //productTax
      showProductTaxMinVatCurrency: false,
      showProductTaxMinCustomsDutyCurrency: false,
    };
  },
  created() {
    const { FPId, IsView, CustomerId } = this.$route.query;
    if (FPId) {
      this.FPId = FPId;
      this.isView = IsView;
      this.CustomerId = CustomerId;
      this.getOptions().then((success) => {
        if (success) {
          this.loadFreightPriceInfo();
        }
      });
    } else {
      this.getOptions();
    }
  },
  methods: {
    handleDelProductTax() {
      if (this.form.DetailList[this.formIndex].ProductTaxList.length > 0) {
        this.form.DetailList[this.formIndex].ProductTaxList.pop();
      }
    },
    handleAddProductTax() {
      this.form.DetailList[this.formIndex].ProductTaxList.push({
        ProductCategory: "",
        VatRate: null,
        MinVatAmount: null,
        MinVatCurrencyId: null,
        MinVatCurrencyIdStr: "",
        CustomsDutyRate: null,
        MinCustomsDutyAmount: null,
        MinCustomsDutyCurrencyId: null,
        MinCustomsDutyCurrencyIdStr: "",
      });
    },
    handleDelByIndex(index) {
      if (this.form.DetailList.length > 0) {
        this.form.DetailList.splice(index, 1);
      }
    },
    handleDel() {
      if (this.form.DetailList.length > 0) {
        this.form.DetailList.pop();
      }
    },
    handleAdd() {
      this.form.DetailList.push({
        CargoCategory: "",
        CargoCategoryEn: "",
        FirstWeight: "",
        FirstWeightPrice: "",
        ContinuousWeight: "",
        ContinuousWeightPrice: "",
        SCId: null,
        SCIdStr: "",
        TransportationDuration: "",
        WMId: null,
        WMIdStr: "",
        WeightUnit: null,
        WeightUnitStr: "",
        Remark: "",
        RemarkEn: "",
        LogoIcon: "",
        ConversionFactor: null,
        LogisticsChannel: null,
        LogisticsChannelStr: null,
        LogisticsProductCode: "",
        LogisticsProductCodeStr: "",
        //tax
        DeclaredValueThreshold: null,
        DeclaredValueCurrencyId: null,
        DeclaredValueCurrencyIdStr: "",
        VatRate: null,
        MinVatAmount: null,
        MinVatCurrencyId: null,
        MinVatCurrencyIdStr: "",
        CustomsDutyRate: null,
        MinCustomsDutyAmount: null,
        MinCustomsDutyCurrencyId: null,
        MinCustomsDutyCurrencyIdStr: "",
        HighValueFee: null,
        HighValueFeeCurrencyId: null,
        HighValueFeeCurrencyIdStr: "",
        ProductTaxList: [
          {
            ProductCategory: "",
            VatRate: null,
            MinVatAmount: null,
            MinVatCurrencyId: null,
            MinVatCurrencyIdStr: "",
            CustomsDutyRate: null,
            MinCustomsDutyAmount: null,
            MinCustomsDutyCurrencyId: null,
            MinCustomsDutyCurrencyIdStr: "",
          },
        ],
      });
    },
    highValueFeeCurrencyConfirm(e) {
      this.form.DetailList[this.itemIndex].HighValueFeeCurrencyIdStr = e.text;
      this.form.DetailList[this.itemIndex].HighValueFeeCurrencyId = e.value;
      this.showQuotationHighValueFeeCurrency = false;
    },
    minCustomsDutyCurrencyConfirm(e) {
      this.form.DetailList[this.itemIndex].MinCustomsDutyCurrencyIdStr = e.text;
      this.form.DetailList[this.itemIndex].MinCustomsDutyCurrencyId = e.value;
      this.showQuotationMinCustomsDutyCurrency = false;
    },
    minVatCurrencyConfirm(e) {
      this.form.DetailList[this.itemIndex].MinVatCurrencyIdStr = e.text;
      this.form.DetailList[this.itemIndex].MinVatCurrencyId = e.value;
      this.showQuotationMinVatCurrency = false;
    },
    declaredValueCurrencyConfirm(e) {
      this.form.DetailList[this.itemIndex].DeclaredValueCurrencyIdStr = e.text;
      this.form.DetailList[this.itemIndex].DeclaredValueCurrencyId = e.value;
      this.showQuotationDeclaredValueCurrency = false;
    },
    dialogProductTaxShow(index) {
      this.formIndex = index;
      this.dialogProductTaxVisible = true;
    },
    //taxProduct
    productTaxMinVatCurrencyConfirm(e) {
      this.form.DetailList[this.formIndex].ProductTaxList[
        this.formItemIndex
      ].MinVatCurrencyIdStr = e.text;
      this.form.DetailList[this.formIndex].ProductTaxList[
        this.formItemIndex
      ].MinVatCurrencyId = e.value;
      this.showProductTaxMinVatCurrency = false;
    },
    productTaxHighValueFeeCurrencyConfirm(e) {
      this.form.DetailList[this.formIndex].ProductTaxList[
        this.formItemIndex
      ].MinCustomsDutyCurrencyIdStr = e.text;
      this.form.DetailList[this.formIndex].ProductTaxList[
        this.formItemIndex
      ].MinCustomsDutyCurrencyId = e.value;
      this.showProductTaxMinCustomsDutyCurrency = false;
    },
    currencyConfirm(e) {
      this.form.DetailList[this.itemIndex].SCIdStr = e.text;
      this.form.DetailList[this.itemIndex].SCId = e.value;
      this.showQuotationFreightCurrency = false;
    },
    warehouseConfirm(e) {
      this.form.DetailList[this.itemIndex].WMIdStr = e.text;
      this.form.DetailList[this.itemIndex].WMId = e.value;
      this.showQuotationFreightWarehouse = false;
    },
    unitConfirm(e) {
      this.form.DetailList[this.itemIndex].WeightUnitStr = e.text;
      this.form.DetailList[this.itemIndex].WeightUnit = e.value;
      this.showQuotationFreightUnit = false;
    },
    countryConfirm(e) {
      this.form.CountryName = e.text;
      this.form.CountryId = e.value;
      this.showQuotationFreightCountry = false;
      this.$forceUpdate();
    },
    channelConfirm(e) {
      this.form.DetailList[this.itemIndex].LogisticsChannelStr = e.text;
      this.form.DetailList[this.itemIndex].LogisticsChannel = e.value;
      this.form.DetailList[this.itemIndex].LogisticsProductCodeStr = "";
      this.form.DetailList[this.itemIndex].LogisticsProductCode = "";
      this.showQuotationFreightChannel = false;
      this.getCodeList(e.value);
    },
    productCodeConfirm(e) {
      this.form.DetailList[this.itemIndex].LogisticsProductCodeStr = e.text;
      this.form.DetailList[this.itemIndex].LogisticsProductCode = e.value;
      this.showQuotationFreightProductCode = false;
    },
    pickerShow(index, pickerName) {
      if (this.isView) {
        return;
      }
      this[pickerName] = true;
      this.itemIndex = index;
      this.$forceUpdate();
    },
    productTaxPickerShow(index, pickerName) {
      this[pickerName] = true;
      this.formItemIndex = index;
      this.$forceUpdate();
    },
    onShowEmit(emit) {
      if (this.isView) {
        return;
      }
      this.$bus.$emit(emit, true);
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getCountryList(),
          this.getCurrencyList(),
          this.getWarehouseInfoList(),
          this.getLogisticsChannelMappings(),
        ])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName_en + " , " + item.CountryName,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getWarehouseInfoList() {
      return new Promise((resolve) => {
        var param = {
          CompanyId: this.CompanyId,
          WarehouseState: 1,
          PageIndex: 1,
          PageSize: 999,
        };
        this.$api.onlineOrderManagement
          .getWarehouseInfoList(param)
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.WarehouseNameSn + " , " + item.WarehouseCode,
                value: item.WMId,
              };
              result.push(data);
            });
            this.warehouseList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getLogisticsChannelMappings() {
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .getLogisticsChannelMappings()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              var codeList = [];
              if (
                item.LogisticsProductCodeList &&
                item.LogisticsProductCodeList.length > 0
              ) {
                for (var code of item.LogisticsProductCodeList) {
                  codeList.push({
                    text: code.Code + " - " + code.Country,
                    value: code.Code,
                  });
                }
              }
              let data = {
                text: item.Channel,
                value: item.Value,
                codeList: codeList,
              };
              result.push(data);
            });
            this.channelList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    loadFreightPriceInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          FPId: this.FPId,
          CustomerId: this.CustomerId,
        };
        this.$api.onlineOrderManagement
          .loadFreightPriceInfo(param)
          .then((res) => {
            this.form = res.data;
            //国家名称
            var country = this.countryList.find((c) => c.value == this.form.CountryId);
            if (country) {
              this.form.CountryName = country.text;
              this.form.CountryId = country.value;
            }
            //国家国旗
            if (this.form.NationalFlagPicture) {
              this.nationalFlagPicture.push({
                url: this.imgUrlFilter(this.form.NationalFlagPicture),
              });
            }
            for (var item of this.form.DetailList) {
              //集货仓库
              if (item.WMId) {
                var warehouse = this.warehouseList.find((c) => c.value == item.WMId);
                if (warehouse) {
                  item.WMIdStr = warehouse.text;
                }
              }
              //重量单位
              if (item.WeightUnit) {
                var unit = this.unitList.find((c) => c.value == item.WeightUnit);
                if (unit) {
                  item.WeightUnitStr = unit.text;
                }
              }
              //服务商
              if (item.LogisticsChannel != null) {
                var channel = this.channelList.find(
                  (c) => c.value == item.LogisticsChannel
                );
                if (channel) {
                  item.LogisticsChannelStr = channel.text;
                }
              }
              //产品编码
              if (item.LogisticsChannel == 2) {
                this.getCodeList(item.LogisticsChannel);
                if (item.LogisticsProductCode) {
                  var productCode = this.productCodeList.find(
                    (c) => c.value == item.LogisticsProductCode
                  );
                  if (productCode) {
                    item.LogisticsProductCodeStr = productCode.text;
                  }
                }
              }
              //货币
              if (item.SCId) {
                var currency1 = this.currencyList.find((c) => c.value == item.SCId);
                if (currency1) {
                  item.SCIdStr = currency1.text;
                }
              }
              //申报价值货币
              if (item.DeclaredValueCurrencyId) {
                var currency2 = this.currencyList.find(
                  (c) => c.value == item.DeclaredValueCurrencyId
                );
                if (currency2) {
                  item.DeclaredValueCurrencyIdStr = currency2.text;
                }
              }
              //VAT最低收费货币
              if (item.MinVatCurrencyId) {
                var currency3 = this.currencyList.find(
                  (c) => c.value == item.MinVatCurrencyId
                );
                if (currency3) {
                  item.MinVatCurrencyIdStr = currency3.text;
                }
              }
              //关税最低收费货币
              if (item.MinCustomsDutyCurrencyId) {
                var currency4 = this.currencyList.find(
                  (c) => c.value == item.MinCustomsDutyCurrencyId
                );
                if (currency4) {
                  item.MinCustomsDutyCurrencyIdStr = currency4.text;
                }
              }
              //高货值申报费货币
              if (item.HighValueFeeCurrencyId) {
                var currency5 = this.currencyList.find(
                  (c) => c.value == item.HighValueFeeCurrencyId
                );
                if (currency5) {
                  item.HighValueFeeCurrencyIdStr = currency5.text;
                }
              }
              //产品税率列表
              if (item.ProductTaxList.length == 0) {
                item.ProductTaxList = [
                  {
                    ProductCategory: "",
                    VatRate: null,
                    MinVatAmount: null,
                    MinVatCurrencyId: null,
                    MinVatCurrencyIdStr: "",
                    CustomsDutyRate: null,
                    MinCustomsDutyAmount: null,
                    MinCustomsDutyCurrencyId: null,
                    MinCustomsDutyCurrencyIdStr: "",
                  },
                ];
              } else {
                for (var productTax of item.ProductTaxList) {
                  productTax.VatRate = productTax.VatRate * 100;
                  productTax.CustomsDutyRate = productTax.CustomsDutyRate * 100;

                  if (productTax.MinVatCurrencyId) {
                    var currency6 = this.currencyList.find(
                      (c) => c.value == productTax.MinVatCurrencyId
                    );
                    if (currency6) {
                      productTax.MinVatCurrencyIdStr = currency6.text;
                    }
                  }

                  if (productTax.MinCustomsDutyCurrencyId) {
                    var currency7 = this.currencyList.find(
                      (c) => c.value == productTax.MinCustomsDutyCurrencyId
                    );
                    if (currency7) {
                      productTax.MinCustomsDutyCurrencyIdStr = currency7.text;
                    }
                  }
                }
              }
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    getCodeList(value) {
      var list = [];
      for (var channel of this.channelList) {
        if (channel.value == value) {
          list = channel.codeList;
        } else {
          list = [];
        }
      }
      this.productCodeList = list;
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      var request = null;
      if (this.FPId) {
        request = this.$api.onlineOrderManagement.editFreightPrice(param);
      } else {
        request = this.$api.onlineOrderManagement.addFreightPrice(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.NationalFlagPicture = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.DetailList[this.filesIndex].LogoIcon = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.quotationFreight {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #646566 !important;
      -webkit-text-fill-color: #646566 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .avatarImg {
    width: 50px;
    height: 50px;
  }
  .quotationFreight-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
      display: inline-flex;
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      background: #1e90ff;
      .multi-table-title {
        font-size: 14px;
        font-family: monospace;
        color: #fff;
        width: 50%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        width: 50%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
        .van-icon {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
        }
      }
    }
  }
  .quotationFreight-dialog {
    top: 50% !important;
    .quotationFreight-alert {
      overflow: scroll;
      height: 120vw;
      margin-top: 30px;
      margin-bottom: 30px;
      ::v-deep .van-field__label {
        width: 160px !important;
      }
    }
  }
}
</style>
